import {
  actionTypes,
  gestTypes,
  privatePhotoAccessedUser,
  privatePhotoRequest,
} from "./photosTypes";

const initialState: photosStateType = {
  photoError: false,
  photoErrorMessage: "",
  photoIsLoading: false,
  firstPhotoLoaded: false,
  photoWasDeleted: false,
  privatePhotosRequests: [],
  privatePhotosAccessedUsers: [],
  loadingPhotosPublic: null,
  loadingPhotosPrivate: null,
  cantDeleteLastPhoto: false,
};

type photosStateType = {
  photoError: boolean;
  photoErrorMessage?: string;
  photoIsLoading: boolean;
  firstPhotoLoaded: boolean;
  photoWasDeleted: boolean;
  privatePhotosRequests: Array<privatePhotoRequest>;
  privatePhotosAccessedUsers: Array<privatePhotoAccessedUser>;
  gesture?: gestTypes;
  verifyResult?: boolean;
  loadingPhotosPublic?: string[] | null;
  loadingPhotosPrivate?: string[] | null;
  cantDeleteLastPhoto: boolean;
};

const photosReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_PHOTO_ERROR:
      return {
        ...state,
        photoError: payload.errStatus,
        photoErrorMessage: payload.errMsg,
      };
    case actionTypes.SET_PHOTO_LOADING:
      return {
        ...state,
        photoIsLoading: payload,
      };
    case actionTypes.SET_FIRST_PHOTO_LOADED:
      return {
        ...state,
        firstPhotoLoaded: payload,
      };
    case actionTypes.SET_PHOTO_WAS_DELETED:
      return {
        ...state,
        photoWasDeleted: payload,
      };
    case actionTypes.SET_PRIVATE_PHOTOS_REQUESTS:
      return {
        ...state,
        privatePhotosRequests: payload,
      };
    case actionTypes.SET_PRIVATE_PHOTOS_ACCESSED_USERS:
      return {
        ...state,
        privatePhotosAccessedUsers: payload,
      };
    case actionTypes.SET_GESTURE:
      return {
        ...state,
        gesture: payload,
      };
    case actionTypes.SET_VERIFY_RESULT:
      return {
        ...state,
        verifyResult: payload,
      };
    case actionTypes.SET_LOADING_PUBLIC:
      return {
        ...state,
        loadingPhotosPublic: payload,
      };
    case actionTypes.SET_LOADING_PRIVATE:
      return {
        ...state,
        loadingPhotosPrivate: payload,
      };
    case actionTypes.SET_CANT_DEL_LAST:
      return {
        ...state,
        cantDeleteLastPhoto: payload,
      };
    default:
      return state;
  }
};

export default photosReducer;
